import Keycloak, { KeycloakAdapter } from "keycloak-js";
import KeycloakPlugin from "./auth-plugin";
import { createPromise, parseCallback, processCallback } from "./adapter-utils";

export const nativeApplicationAdapter: (kc: Keycloak) => KeycloakAdapter = (kc) => ({
  accountManagement(): Promise<void> {
    return createPromise();
  },
  login(options?: Keycloak.KeycloakLoginOptions): Promise<void> {
    const promise = createPromise();
    const url = kc.createLoginUrl(options);
    KeycloakPlugin.handleUrl({ url });
    KeycloakPlugin.addListener("authorizationCode", (data: any) => {
      const oauth = parseCallback(data.url, kc);
      if (oauth) {
        processCallback(oauth, promise, kc);
      }
    });
    return promise;
  },
  logout(options?: Keycloak.KeycloakLogoutOptions): Promise<void> {
    const promise = createPromise();
    const url = kc.createLogoutUrl(options);

    KeycloakPlugin.handleUrl({ url });
    KeycloakPlugin.addListener("authorizationCode", () => {
      kc.clearToken();
      // @ts-ignore
      promise.setSuccess();
    });
    return promise;
  },
  redirectUri(options: { redirectUri: string }): string {
    if (options && options.redirectUri && kc.redirectUri) {
      // If the redirect url is not empty then we need to create application url
      // And should skip the silent-check-sso page
      const slug = options.redirectUri.split(window.location.origin);
      if (slug[1] && slug[1].indexOf("silent-check-sso") === -1) {
        return kc.redirectUri.concat(slug[1]);
      }
      // Handle silent-check-sso page
      return options.redirectUri;
    } else if (kc.redirectUri) {
      return kc.redirectUri;
    } else {
      return "http://localhost";
    }
  },
  register(options?: Keycloak.KeycloakRegisterOptions): Promise<void> {
    const promise = createPromise();
    const url = kc.createRegisterUrl(options);
    KeycloakPlugin.handleUrl({ url });
    KeycloakPlugin.addListener("authorizationCode", (data: any) => {
      const oauth = parseCallback(data.url, kc);
      processCallback(oauth, promise, kc);
    });
    return promise;
  }
});
